import{createContext as e}from"../../external/preact/dist/preact.js";const s=e({srPanel:null,setSRMessagesFromObjects:null,setSRMessagesFromStrings:null,clearSRPanel:null,shouldMoveFocusSR:null});export{s as SRPanelContext};
//# sourceMappingURL=SRPanelContext.js.map
